
// components/UploadedFilesDialog.js

import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Paper,
    Stack,
    IconButton,
    Typography,
    Button,
    Box
} from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { adminUrl } from '../../../../constants';

const UploadedFilesDialog = ({ open, onClose, files = [], onDownload, onRemove, selectedYear }) => {
    const dispatch = useDispatch();
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const { deletePdfByName } = useSelector((state) => state?.deletePdfByName);


    useEffect(() => {
        if (!open){
            return
        }
        const fetchData = async () => {


            const data1 = {
                data: {},
                method: "get",
                apiName: `getPdfsByAppraisalYear?appraisal_year=${selectedYear}`
            };
            const responseData = await dispatch(actions.GETPDFSBYAPPRAISALYEAR(data1));
            console.log(responseData, "getAppraisalYearById")

            const message = responseData?.payload?.message;

            const pattern = /^Found\s+\d+\s+PDF\(s\)\s+under\s+appraisal_year\s+'(\d{4}-\d{2})'\.?$/;

            if (pattern.test(message)) {
                const match = message.match(pattern);
                console.log(match, "matchhhh")
                const appraisalYear = match[1]; // e.g., "2029-30"
                console.log("✅ Valid message with appraisal year:", appraisalYear);

            } else {
                console.log("❌ Invalid message format.");
            }
            const match = message.match(pattern);


            if (responseData?.payload?.message === match[0]) {
                // setLoading(false)
                // setEditData(responseData?.payload?.data)
                const files = responseData?.payload?.data || [];
                setUploadedFiles(files);
                // setOpenDialog(true);
            }
        }
        fetchData()

    }, [dispatch, selectedYear, deletePdfByName])

    // const handleDownload = async (file) => {
    //     const fileName = typeof file === 'string' ? file : file.name;
    //     const year = file?.year || 'default-year'; // Replace with actual logic if needed

    //     const data = {
    //         data: {},
    //         method: "get",
    //         apiName: `downloadPdfByName/year/${selectedYear}/filenName/${fileName}`
    //     };

    //     try {
    //         const response = await dispatch(actions.DOWNLOADPDFBYNAME(data));
    //         console.log(response, "Download response");

    //         // Open download link or handle blob
    //         window.open(`/your-download-endpoint/${fileName}`, '_blank');

    //         // Optional: notify parent
    //         onDownload?.(file);
    //     } catch (error) {
    //         console.error("Download failed", error);
    //     }
    // };


    const authToken = localStorage.getItem("authToken");

    const handleDownload = async (fileName) => {
        try {
            const response = await fetch(`${adminUrl}downloadPdfByName/year/${selectedYear}/filenName/${fileName}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;

            // Use the original file name (fallback to 'download.pdf' if not available)
            a.download = fileName || 'download.pdf';

            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };

    const handleRemoveFile = async (file, index) => {
        const fileName = typeof file === 'string' ? file : file.name;
        const year = file?.year || 'default-year'; // Replace with actual logic if needed

        const data = {
            data: {},
            method: "delete",
            apiName: `deletePdfByName/year/${selectedYear}/filenName/${fileName}`
        };

        try {
            const response = await dispatch(actions.DELETEPDFBYNAME(data));
            console.log(response, "Delete response");

            // Notify parent to remove from UI
            // onRemove?.(index);
        } catch (error) {
            console.error("Delete failed", error);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="paper">
            <DialogTitle><Typography variant='h6'>Uploaded PDF Files <span style={{fontSize:"14px",color:"gray"}}>(Only delete the PDF)</span></Typography></DialogTitle>
            <DialogContent dividers>
                {uploadedFiles.length > 0 ? (
                    uploadedFiles.map((file, index) => (
                        <Paper key={index} elevation={3} sx={{ p: 2, mb: 2 }}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <InsertDriveFileIcon sx={{ fontSize: 50, color: 'var(--main-color)' }} />
                                <Box flexGrow={1}>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        {file}
                                    </Typography>
                                    <Stack direction="row" spacing={1} mt={1}>
                                        <IconButton color="success" onClick={() => handleDownload(file)}>
                                            <DownloadIcon />
                                        </IconButton>
                                        <IconButton color="error" onClick={() => handleRemoveFile(file, index)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Stack>
                                </Box>
                            </Stack>
                        </Paper>
                    ))
                ) : (
                    <Typography>No files uploaded.</Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default UploadedFilesDialog;
